import type { JSONSchema7 } from 'json-schema';

export type ApplicationMetadataFieldUiOptions = {
  entityField: string;
  source?: 'annotation' | 'description';
  annotation?: string;
  rows?: number;
};

export const ApplicationMetadataFieldSchema = {
  uiOptions: {
    type: 'object',
    required: ['entityField'],
    properties: {
      entityField: {
        type: 'string',
        title: 'Entity field',
        description: 'Form field containing the selected catalog entity',
      },
      source: {
        type: 'string',
        title: 'Entity value source',
        enum: ['annotation', 'description'],
        default: 'annotation',
      },
      annotation: {
        type: 'string',
        title: 'Annotation',
        description: 'Entity annotation used to prefill this field',
      },
      rows: {
        type: 'number',
        title: 'Rows',
      },
    },
  } as JSONSchema7,
  returnValue: {
    title: 'Application metadata value',
    type: 'string',
  } as JSONSchema7,
};
